/** Labels the server-projected price without inferring its meaning from the band. */
export function priceLabel(kind?: string, approximate?: boolean): string {
  let label: string;
  switch (kind) {
    case "shopping_range":
      return "Shopping range";
    case "property_bracket":
      label = "Target property price";
      break;
    case "target_bracket":
      label = "Target price";
      break;
    default:
      label = "Price bracket";
  }
  return approximate ? `${label} · approximate` : label;
}
